import { Outlet } from 'react-router-dom'
import artaLogo from 'assets/img/logo.png'
import { appVersion } from 'version'
import LoginArtWork from 'views/components/Artwork/LoginArtwork'

export default function AuthLayout () {
  return (
    <div className="artapay-auth-shell">
      <section className="artapay-auth-story" aria-label="ArtaPay platform introduction">
        <div className="artapay-auth-brand">
          <span><img src={artaLogo} alt="" /></span>
          <div>
            <strong>ArtaPay</strong>
            <small>By Artamedia Indonesia</small>
          </div>
        </div>
        <LoginArtWork/>
      </section>
      <section className="artapay-auth-panel">
        <Outlet />
        <p className="artapay-auth-copyright">© {new Date().getFullYear()} PT Artamedia Citra Telematika Indonesia v {appVersion}</p>
      </section>
    </div>
  )
}
